import util from "@/util";
import svgDone from '@/assets/imgs/done.svg'
import svgTodo from '@/assets/imgs/todo.svg'

function getSpStorage() {
    let str = localStorage.getItem("spTable");
    if (str)
        return JSON.parse(str);
    return {};
}

let spTS = getSpStorage()

function getIsHide(key, defaultVal = false) {
    // eslint-disable-next-line no-prototype-builtins
    if (spTS.hasOwnProperty(key))
        return !spTS[key];
    else
        return defaultVal
}

function fJine(jine, currency) {
    let res = `<b style="font-size: 16px;color: orange;">${util.getCurrencyCode(currency)}${(jine - 0).toFixed(2)}</b>`;
    return res;
}

function tpl(key, key1, key2) {
    return function (d) {
        let val = d[key] && typeof d[key][key1] != 'undefined' && d[key][key1] !== null ? d[key][key1] : '';
        if (val && key2 && val[key2]) {
            return val[key2]
        } else {
            return val;
        }
    }
}

let cols = [[
    {field: 'manage', title: '操作', templet: '#manage', fixed: 'left', width: 60},
    // {type: 'checkbox'},
    {field: 'id', title: 'ID', sort: true, hide: getIsHide('id', true)},
    {field: '$.zi', title: '字', sort: true, templet: tpl('data', 'zi'), hide: getIsHide('$.zi')},
    {field: 'rp.NAME_', title: '流程分类', sort: true, templet: tpl('data', 'title'), hide: getIsHide('rp.NAME_'), width: 107},
    {field: '$.type', title: '流程类型', sort: true, templet: tpl('data', 'subTitle'), hide: getIsHide('$.subTitle'), width: 107},
    {field: '$.shoukuan', title: '收款单位', sort: true, templet: tpl('data', 'shoukuan'), hide: getIsHide('$.shoukuan', true)},
    {field: '$.zhanghao', title: '账号', sort: true, templet: tpl('data', 'zhanghao'), hide: getIsHide('$.zhanghao', true)},
    {field: '$.kaihuhang', title: '开户行', sort: true, templet: tpl('data', 'kaihuhang'), hide: getIsHide('$.kaihuhang', true)},
    {
        field: '$.jine', title: '金额', sort: true, templet(d) {
            return fJine(d.data && d.data.jine || 0, d.data.currency);
        }, hide: getIsHide('$.jine')
    },
    {
        field: '$.currency', title: '币种', sort: true, templet: tpl('data', 'currency'), hide: getIsHide('$.currency'), width: 75
    },
    {field: '$.fukuanNeirong', title: '付款内容', sort: true, templet: tpl('data', 'fukuanNeirong'), hide: getIsHide('$.fukuanNeirong', true)},
    {field: '$.caigouNeirong', title: '采购内容', sort: true, templet: tpl('data', 'caigouNeirong'), hide: getIsHide('$.caigouNeirong', true)},
    {
        field: '$.caigouQingdanGyl', title: '采购清单', sort: false, templet(d) {
            if (d.data && d.data.caigouQingdanGyl) {
                let res = '';
                d.data.caigouQingdanGyl.forEach(item => {
                    res += `${item.name} ${item.danjia && item.danjia.toFixed(2) || '0.00'}元 * ${item.shuliang}; `;
                });
                return res;
            }
            return '';
        }, hide: getIsHide('$.caigouQingdanGyl', true)
    },
    {field: '$.tuiguangNeirong', title: '推广内容', sort: true, templet: tpl('data', 'tuiguangNeirong'), hide: getIsHide('$.tuiguangNeirong', true)},
    {
        field: '$.zujinShuidianYuefen', title: '租金水电月份', sort: false, templet(d) {
            if (d.data && d.data.zujinShuidianYear && d.data.zujinShuidianMonth)
                return `${d.data.zujinShuidianYear}年${d.data.zujinShuidianMonth}月`;
            return '';
        }, hide: getIsHide('$.zujinShuidianYuefen', true)
    },
    {field: '$.serverZhanghao', title: '服务器账号', sort: true, templet: tpl('data', 'serverZhanghao'), hide: getIsHide('$.serverZhanghao', true)},
    {field: '$.fuwushang', title: '服务商', sort: true, templet: tpl('data', 'fuwushang'), hide: getIsHide('$.fuwushang', true)},
    {
        field: '$.yongtus', title: '报销用途', sort: false, templet(d) {
            if (d.data && d.data.yongtus) {
                let res = '';
                d.data.yongtus.forEach(item => {
                    res += `${item.name} ${item.jine && parseFloat(item.jine).toFixed(2) || '0.00'}元; `;
                });
                return res;
            }
            return '';
        }, hide: getIsHide('$.yongtus')
    },
    {
        field: '$.kuanxiangs', title: '结算款项', sort: false, templet(d) {
            if (d.data && d.data.kuanxiangs) {
                let res = '';
                d.data.kuanxiangs.forEach(item => {
                    res += `${item.name} ${util.toFiexd(item.jine, '元')} ${item.bumen}; `;
                });
                return res;
            }
            if (d.data && d.data.kuanxiangsGz) {
                let res = '';
                d.data.kuanxiangsGz.forEach(item => {
                    res += `${item.bumen} ${util.toFiexd(item.jine, '元')}; `;
                });
                return res;
            }
            return '';
        }, hide: getIsHide('$.kuanxiangs', true)
    },
    {
        field: '$.jiesuanYear', title: '结算月份', sort: false, templet(d) {
            if (d.data && d.data.jiesuanYear)
                return `${d.data.jiesuanYear}年${d.data.jiesuanMonth && (d.data.jiesuanMonth + '月') || ''}`;
            return '';
        }, hide: getIsHide('$.jiesuanYear', true)
    },
    {field: '$.lingkuanren', title: '领款人', templet: tpl('data', 'lingkuanren'), hide: getIsHide('$.lingkuanren', true)},
    {
        field: '$.yuanjiekuan', title: '原借款', sort: true, templet(d) {
            if (d.data.yuanjiekuan == null) return '';
            return fJine(d.data && d.data.yuanjiekuan || 0, d.data.currency);
        }, hide: getIsHide('$.yuanjiekuan', true)
    },
    {
        field: '$.yingtuikuan', title: '应退款', sort: true, templet(d) {
            if (d.data.yingtuikuan == null) return '';
            return fJine(d.data && d.data.yingtuikuan || 0, d.data.currency);
        }, hide: getIsHide('$.yingtuikuan', true)
    },
    {field: '$.yuanyin', title: '备注', sort: true, templet: tpl('data', 'yuanyin'), hide: getIsHide('$.yuanyin')},
    {field: '$.startUser.name', title: '申请人', sort: true, templet: tpl('data', 'startUser', 'name'), hide: getIsHide('$.startUser.name'), width: 90},
    {field: '$.bumen', title: '申请部门', sort: true, templet: tpl('data', 'bumen'), hide: getIsHide('$.bumen'), width: 130},
    {field: '$.zhuguanUser.name', title: '主管', sort: true, templet: tpl('data', 'zhuguanUser', 'name'), hide: getIsHide('$.zhuguanUser.name', true), width: 90},
    {field: '$.caiwuUser.name', title: '财务', sort: true, templet: tpl('data', 'caiwuUser', 'name'), hide: getIsHide('$.caiwuUser.name', true), width: 90},
    {field: '$.caiwujingliUser.name', title: '财务经理', sort: true, templet: tpl('data', 'caiwujingliUser', 'name'), hide: getIsHide('$.caiwujingliUser.name', true), width: 90},
    {field: '$.beizhuFukuanZhanghao', title: '付款账号', sort: true, templet: tpl('data', 'beizhuFukuanZhanghao'), hide: getIsHide('$.beizhuFukuanZhanghao')},
    {field: '$.fukuanPizhu', title: '付款批注', sort: true, templet: tpl('data', 'fukuanPizhu'), hide: getIsHide('$.fukuanPizhu')},
    {field: '$.zongjingbanUser.name', title: '总经办', sort: true, templet: tpl('data', 'zongjingbanUser', 'name'), hide: getIsHide('$.zongjingbanUser.name', true), width: 90},
    {field: '$.chunaUser.name', title: '出纳', sort: true, templet: tpl('data', 'chunaUser', 'name'), hide: getIsHide('$.chunaUser.name', true), width: 90},
    {field: '$.qianshouUser.name', title: '货物签收', sort: true, templet: tpl('data', 'qianshouUser', 'name'), hide: getIsHide('$.qianshouUser.name', true), width: 90},
    {
        field: '$.fujians', title: '附件', sort: true, templet(d) {
            if (d.data.fujians && d.data.fujians.length) {
                let resHtml = '';
                d.data.fujians.forEach((item, i) => {
                    resHtml += `<a class="btn" title="${item}" onclick="openFujian(${d.LAY_INDEX - 1}, ${i})" href="javascript:;">
                                            <i class="layui-icon ${util.isImg(item) ? 'layui-icon-picture' : 'layui-icon-file'}"></i>
                                        </a>`
                })
                return resHtml;
            }
            return '';
        }, hide: getIsHide('$.fujians')
    },
    {
        field: 'hp.start_time_', title: '创建', sort: true, templet(d) {
            return d.startTime ? util.friendlyDate1(d.startTime) : '';
        }, hide: getIsHide('hp.start_time_'), width: 100
    },
    {
        field: 'hp.end_time_', title: '完成', sort: true, templet(d) {
            return d.endTime ? util.friendlyDate1(d.endTime) : '';
        }, hide: getIsHide('hp.end_time_'), width: 100
    },
    {
        field: 'rt.NAME_', title: '当前节点', sort: true, templet(d) {
            if (d.actRuTask && d.actRuTask.name) {
                return `<img class="icon" src="${svgTodo}">${d.actRuTask.name}`;
            }
            return `<img src="${svgDone}" class="icon" title="已完成">已完成`;
        }, hide: getIsHide('rt.NAME_')
    },
]];

export default {
    cols: cols,
    getTableParams() {
        let p = localStorage.getItem('tableParams');
        p = p ? JSON.parse(p) : {};
        return p;
    },
    setTableParams(key, val) {
        let p = this.getTableParams();
        p[key] = val;
        localStorage.setItem('tableParams', JSON.stringify(p));
    },
    getSpStorage: getSpStorage,
    saveSpStorage(spTable) {
        localStorage.setItem("spTable", JSON.stringify(spTable));
    },
    getTableField() {
        let fields = [];
        for (let i = 0; i < cols[0].length; i++) {
            if (i === 0 || i === cols[0].length - 1) continue;
            let item = cols[0][i];
            fields.push(item.title)
        }
        return fields;
    },
    getTableValueByData(data) {
        let res = [];
        for (let j = 0; j < data.length; j++) {
            let d = data[j];
            let valArr = [];
            for (let i = 0; i < cols[0].length; i++) {
                if (i === 0 || i === cols[0].length - 1) continue;
                let item = cols[0][i];
                let value = this.getValue(d, item);
                valArr.push(value)
            }
            res.push(valArr);
        }
        return res;
    },
    getValue(data, col) {
        // eslint-disable-next-line no-prototype-builtins
        let hasT = col.hasOwnProperty('templet');
        let res = '';
        if (col.title === '金额') {
            res = data.data.jine;
        } else if (col.title === '原借款') {
            res = data.data.yuanjiekuan;
        } else if (col.title === '应退款') {
            res = data.data.yingtuikuan;
        } else if (col.title === '附件') {
            res = data.data.fujians && data.data.fujians.length || 0;
        } else if (col.title === '当前节点') {
            res = data.actRuTask && data.actRuTask.name || '已完成'
        } else if (col.title === '备注') {
            let yy = data.data.yuanyin || '';
            yy = yy.replace(/\n/g, ' ');
            yy = yy.replace(/,/g, '，');
            res = yy;
        } else if (col.title === '付款批注') {
            let yy = data.data.fukuanPizhu || '';
            yy = yy.replace(/\n/g, ' ');
            yy = yy.replace(/,/g, '，');
            res = yy;
        } else if (col.title === '创建') {
            if (data.startTime)
                res = new Date(data.startTime.replace(/-/g, '/')).Format('yyyy/MM/dd');
        } else if (col.title === '完成') {
            if (data.endTime)
                res = new Date(data.endTime.replace(/-/g, '/')).Format('yyyy/MM/dd');
        } else if (!hasT) {
            res = data[col.field];
        } else {
            res = col.templet(data);
        }
        return res !== null && res !== undefined && res || '';
    }
};
